module.exports = __webpack_public_path__ + "static/media/r18.f32e13dd.jpg";